/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_Draft_LabelInputs */

const en_wb_support_draft_label = /** @type {(inputs: Wb_Support_Draft_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft prepared by your system`)
};

const lv_wb_support_draft_label = /** @type {(inputs: Wb_Support_Draft_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melnrakstu sagatavoja Jūsu sistēma`)
};

/**
* | output |
* | --- |
* | "Draft prepared by your system" |
*
* @param {Wb_Support_Draft_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_draft_label = /** @type {((inputs?: Wb_Support_Draft_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_Draft_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_draft_label(inputs)
	return en_wb_support_draft_label(inputs)
});